// extracted by mini-css-extract-plugin
export default {"protectedAppOutletContainer":"ProtectedAppOutlet_protectedAppOutletContainer__Q4nt7","protectedAppOutletWrapper":"ProtectedAppOutlet_protectedAppOutletWrapper__ocRX5"};